import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MsalGuardConfiguration, MsalService, MSAL_GUARD_CONFIG } from '@azure/msal-angular';
import { RedirectRequest } from '@azure/msal-browser';
import { VersionNumberComponent } from '../version-number/version-number.component';
import { Button } from 'primeng/button';
import { LoginFooterComponent } from '../login-footer/login-footer.component';

@Component({
  selector: 'cmg-clear2-ui-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [VersionNumberComponent, Button, LoginFooterComponent],
})
export class LoginComponent {
  private readonly _msalGuardConfig = inject<MsalGuardConfiguration>(MSAL_GUARD_CONFIG);
  private readonly _msalService = inject(MsalService);

  login(): void {
    if (this._msalGuardConfig.authRequest) {
      this._msalService.loginRedirect({ ...(this._msalGuardConfig.authRequest as RedirectRequest) });
    } else {
      this._msalService.loginRedirect();
    }
  }
}
